import { useQuery } from '@tanstack/react-query';
import {
  searchShipments,
  getShipment,
  searchInvoices,
  getAccounts,
  getAccountAging,
  getCarriers,
  getPackageStatuses,
} from '../api';
import { pcKeys } from './queryKeys';
import type { ShipmentSearchFilters, InvoiceSearchFilters } from '../types';

export function useShipments(filters: ShipmentSearchFilters = {}) {
  return useQuery({
    queryKey: pcKeys.shipmentList(filters),
    queryFn: () => searchShipments(filters),
  });
}

export function useShipmentDetail(number: string, enabled = true) {
  return useQuery({
    queryKey: pcKeys.shipmentDetail(number),
    queryFn: () => getShipment(number),
    enabled: !!number && enabled,
  });
}

export function useInvoices(filters: InvoiceSearchFilters = {}) {
  return useQuery({
    queryKey: pcKeys.invoiceList(filters),
    queryFn: () => searchInvoices(filters),
  });
}

export function usePCAccounts() {
  return useQuery({
    queryKey: pcKeys.accounts(),
    queryFn: getAccounts,
    staleTime: 5 * 60 * 1000,
  });
}

export function useAccountAging(accountNumber: string) {
  return useQuery({
    queryKey: pcKeys.aging(accountNumber),
    queryFn: () => getAccountAging(accountNumber),
    enabled: !!accountNumber,
  });
}

export function useCarriers() {
  return useQuery({
    queryKey: pcKeys.carriers(),
    queryFn: getCarriers,
    staleTime: 10 * 60 * 1000,
  });
}

export function usePackageStatuses() {
  return useQuery({
    queryKey: pcKeys.packageStatuses(),
    queryFn: getPackageStatuses,
    staleTime: 10 * 60 * 1000,
  });
}
